module.exports = __webpack_public_path__ + "img/hr-brown-fluff-dry-12.321e8697.png";